import React from 'react';
import theme from './DescriptiveRadio.module.scss';
import Radio, { RadioProps } from './Radio';
import { TranslatableText } from '@/types';

interface DescriptiveRadioProps extends RadioProps {
    text: TranslatableText;
    description?: TranslatableText;
}

const DescriptiveRadio: React.FC<DescriptiveRadioProps> = ({ text, description, ...rest }) => {
    return (
        <Radio labelClassName={theme.label} boxClassName={theme.box} {...rest}>
            <span className={theme.mainText}>{text}</span>
            {description && <small className={theme.description}>{description}</small>}
        </Radio>
    );
};

export default DescriptiveRadio;
